import { combineReducers, configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import {
	authReducer,
	screenStateReducer,
	tradingReducer,
	profileReducer,
	depositReducer,
	withdrawReducer,
	cachedReducer,
	profitReducer,
} from './allReducers';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';

const persistConfig = {
	key: 'root',
	version: 1,
	storage,
	whitelist: ['authReducer', 'cachedReducer'],
};

const rootReducer = combineReducers({
	authReducer,
	screenStateReducer,
	tradingReducer,
	profileReducer,
	depositReducer,
	withdrawReducer,
	cachedReducer,
	profitReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
	reducer: persistedReducer,
	middleware: [thunk],
	devTools: process.env.NODE_ENV !== 'production',
});

export { store };

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
